import { Element } from 'domhandler';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
import { HashLink } from 'react-router-hash-link';

export function transformCmsData(node: Element, index: number) {
  if (
    node.type === 'tag' &&
    node.name === 'a' &&
    node.attribs?.href?.[0] === '/'
  ) {
    const {
      attribs: { href, 'data-testid': dataTestId },
    } = node;
    return (
      <HashLink to={href} data-testid={dataTestId}>
        {convertNodeToElement(
          {
            ...node,
            name: 'span',
            attribs: {
              ...node.attribs,
              href: undefined,
              'data-testid': undefined,
            },
          },
          index,
          transformCmsData
        )}
      </HashLink>
    );
  }
  return convertNodeToElement(node, index, transformCmsData);
}

export function parseHTML(html: string) {
  return ReactHtmlParser(html, { transform: transformCmsData });
}
